<template>
  <div>
    <div class="ui form">
      <div class="field" v-for="(fld, idx) in custom_fields" :key="idx">
        <label for="">{{ fld.name }}</label>
        <textarea
          v-model="custom_fields[idx].value"
          @keyup="change(fld, idx)"
          rows="3"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuotationModalCustomContent",
  components: {},
  props: { quotation_in: Object, setup: Object },
  data() {
    return {
      custom_fields: [],
    };
  },
  methods: {
    render(template) {
      let vm = this;
      let mixin = {};
      vm.custom_fields = vm.custom_fields || [];
      if (!vm.custom_fields.length) {
        try {
          if (template.js) eval(`mixin = ${template.js}`);
          if (mixin.data) {
            let data = mixin.data();
            Object.keys(data).map((k) => {
              vm.custom_fields.push({
                name: k,
                value: data[k],
              });
            });
          }
        } catch (ex) {
          console.error(ex);
        }
      }

      if (
        vm.quotation_in &&
        vm.quotation_in.setup &&
        vm.quotation_in.setup.custom
      ) {
        vm.quotation_in.setup.custom.map((c) => {
          let trgt = vm.custom_fields.find((f) => f.name == c.name);
          if (trgt) {
            trgt.value = c.value;
          }
        });
      }
    },
    change(field) {
      let vm = this;
      vm.custom_fields[field.name] = field.value;
      vm.$emit("update_custom", vm.custom_fields);
    },
    getData() {
      return this.custom_fields;
    },
  },
  computed: {},
  created() {},
  beforeMount() {},
  mounted() {},
};
</script>
